import { useEffect, useState } from "react";

import * as appConst from "@app/state/constants";

export default function useWindowDimensions() {
  const hasWindow = typeof window !== "undefined";
  function getWindowDimensions() {
    const width = hasWindow ? window.innerWidth : null;
    const height = hasWindow ? window.innerHeight : null;
    const drawerHeight = height ? height - appConst.SIZES.headerHeight : null;
    const jgDrawerHeight = height
      ? height - appConst.SIZES.jgHeaderHeight - 4 - 3
      : null;
    const rightreserved = appConst.SIZES.drawerWidth;
    return {
      width,
      height,
      drawerHeight: drawerHeight || 0,
      jgDrawerHeight: jgDrawerHeight || 0,
      headersFooters: 4,
      rightReserved: rightreserved,
      appIsPersonalKarma: true,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  function handleResize() {
    setWindowDimensions(getWindowDimensions());
  }
  useEffect(() => {
    if (hasWindow) {
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, [hasWindow]);

  return windowDimensions;
}
